import BaseClass from "./BaseClass";
import Timer from "./utils/Timer";

const defaultOptions = {};

export default class TimersInits extends BaseClass {
  constructor(options) {
    super(options, defaultOptions);
    this.init();
  }

  init() {
    $(document).ready(() => {
      // RESERVATION THANK YOU PAGE
      if ($("[data-reservationThankYou]").length > 0) {
        let timer = new Timer(Timer.compareSeconds, 5, () => {
          window.location.href =
            window.location.origin +
            "/reservation-id/" +
            $("input[name='bookingID']").val();
        });
        timer.setTimerElement('[data-timer="seconds"]');
        timer.start();
      }

      // UNAUTHORIZED TIMER
      if ($("[data-unauthorized]").length > 0) {
        let timer = new Timer(Timer.compareSeconds, 5, () => {
          window.location.href =
            window.location.origin;
        });
        timer.setTimerElement('[data-timer="seconds"]');
        timer.start();
      }

      // REVIEW THANK YOU PAGE
      if($("[data-reviewThankYou]").length > 0) {
        let isLogged = $("input[name='is_logged']").val();
        let bookingID = $("input[name='booking']").val();

        let url = '/' + document.documentElement.lang + (isLogged ? '/user/reviews' : '/');

        let timer = new Timer(Timer.compareSeconds, 5, () => {
          window.location.href = window.location.origin + url;
        });
        timer.setTimerElement('[data-timer="seconds"]');
        timer.start();
      }

       // EMAIL ACTIONS PAGE
       if($("[data-emailAction]").length > 0) {
        let url = $("[data-emailAction]").data('emailaction');

        let timer = new Timer(Timer.compareSeconds, 5, () => {
          window.location.href = url;
        });
        timer.setTimerElement('[data-timer="seconds"]');
        timer.start();
      }
    });
  }
}
